import script from "./BestGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BestGroup.vue?vue&type=script&setup=true&lang=js"

import "./BestGroup.vue?vue&type=style&index=0&id=41f48376&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f48376"]])

export default __exports__